import React, { RefObject } from "react";
import Upload from "../../../../assets/tryai-icons/Upload";

interface UploadImageButtonProps {
  describedBy: string;
  hasError: boolean;
  inputRef: RefObject<HTMLInputElement>;
  onFileSelected: (file?: File) => void;
}

const UploadImageButton: React.FC<UploadImageButtonProps> = ({
  describedBy,
  hasError,
  inputRef,
  onFileSelected,
}) => (
  <div id="upload-image__btn">
    <input
      accept="image/*"
      aria-describedby={describedBy}
      aria-invalid={hasError}
      aria-label="Upload a photo for the selected procedure"
      id="upload-image__input"
      multiple={false}
      onChange={(event) => onFileSelected(event.target.files?.[0])}
      ref={inputRef}
      type="file"
    />
    <span id="upload-image__span">Upload a photo</span>
    <div aria-hidden="true" id="upload-image__upload-icon">
      <Upload />
    </div>
  </div>
);

export default UploadImageButton;
